/* eslint-disable */
import React, { useContext, useEffect, useState } from 'react'
import range from 'lodash/range'
import { FormattedMessage } from 'react-intl'

import Table from 'components/Table'
import ItemsPerPageDropdown from 'components/ItemsPerPageDropdown'
import Pagination from 'features/Pagination'
import sortDirection from 'constants/sortDirection'
import Select from 'components/Select'
import siteStatuses, {
  SITE_STATUS_CONFIRMED_ID,
  SITE_STATUS_SUPERSEDED_ID,
  SITE_STATUS_DELISTED_ID,
  SITE_STATUS_EDIT_ONLY_ID,
  SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
} from 'constants/siteStatuses'

import {
  requestConfirmState,
  requestGetSites,
  requestNominateSite,
  requestReviewByRfp,
  requestAllSitesReassessments,
  deleteSiteRequest,
  requestDoesNotQualify,
  requestGetSitesSearch,
  requestReassesSite,
  requestDelistState,
  requestEditSite,
  requestApproveEdits,
  deleteEditSiteOnlyRequest
} from 'api/site'
import { usePersistPagination } from 'hooks/usePersistPagination'
import Modal from 'components/Modal'
import SiteSupersedeModal from './SiteModals/SiteSupersedeModal'
import AssessmentModal from './SiteModals/AssessmentModal'
import { INDIVIDUAL_ROLE_ID, NCG_ROLE_ID } from 'constants/roles'
import { canReviewSites, canConfirmSites } from 'utils/rolePermissions'
import SearchInput from 'components/SearchInput'
import GlobeIcon from 'assets/icons/sidebar-sites'

import {
  SiteFilterValueWrapper,
  SitesFilterItemWrapper,
  SitesFilterSearchWrapper,
  SitesFilterWrapper,
  SitesFooterWrapper,
  SitesTableIconConfirmed,
  SitesTableIconDelistedWrapper,
  SitesTableIconDraft,
  SitesTableIconEditOnly,
  SitesTableIconNominated,
  SitesTableIconNotQualifyWrapper,
  SitesTableIconProposed,
  SitesTableIconProposedEditOnlyWrapper,
  SitesTableIconReviewedRFP,
  SitesTableIconSuperseded,
  SitesTableWrapper,
  SiteTableIconDelisted
} from './style'
import { makeSitesColumns, makeSitesRows } from './sitesTable'
import SiteRevertStatusModal from './SiteModals/SiteRevertStatusModal'
import FlowRequestModal from 'components/FlowRequestModal'
import { ProfileContext } from 'providers/profile'
import { MySiteContext } from 'providers/mySiteProvider'
import { showErrorToast } from 'utils/toast'
import { CountriesContext } from 'providers/countries'
import { SitesSearchInputWrapper, SitesSearchWrapper, ResponsiveComponent } from 'pages/SitesManagement/style'
import { SitesModalContext } from 'providers/sitesProviders'
import { useNavigate } from 'react-router-dom'
import { buildDetailsUrl, editOnly, SITES_MAP_PATH } from 'routing/constants'
import Button from 'components/Button'
import LoadingWrapper from 'components/LoadingWrapper'

const statusMapping = {
  Draft: (
    <SiteFilterValueWrapper>
      <SitesTableIconDraft />
      Draft
    </SiteFilterValueWrapper>
  ),
  Proposed: (
    <SiteFilterValueWrapper>
      <SitesTableIconProposed />
      Proposed
    </SiteFilterValueWrapper>
  ),
  Nominated: (
    <SiteFilterValueWrapper>
      <SitesTableIconNominated />
      Nominated
    </SiteFilterValueWrapper>
  ),
  'Reviewed by RFP': (
    <SiteFilterValueWrapper>
      <SitesTableIconReviewedRFP />
      Reviewed by RFP
    </SiteFilterValueWrapper>
  ),
  Confirmed: (
    <SiteFilterValueWrapper>
      <SitesTableIconConfirmed />
      Confirmed
    </SiteFilterValueWrapper>
  ),
  Superseded: (
    <SiteFilterValueWrapper>
      <SitesTableIconSuperseded />
      Superseded
    </SiteFilterValueWrapper>
  ),
  Delisted: (
    <SiteFilterValueWrapper>
      <SitesTableIconDelistedWrapper>
        <SiteTableIconDelisted />
      </SitesTableIconDelistedWrapper>
      Delisted
    </SiteFilterValueWrapper>
  ),
  'Does not Qualify': (
    <SiteFilterValueWrapper>
      <SitesTableIconNotQualifyWrapper />
      Does not Qualify
    </SiteFilterValueWrapper>
  ),
  'Edit Only': (
    <SiteFilterValueWrapper>
      <SitesTableIconEditOnly />
      Edit only
    </SiteFilterValueWrapper>
  ),
  'Submitted Edits': (
    <SiteFilterValueWrapper>
      <SitesTableIconProposedEditOnlyWrapper />
      Edits submitted
    </SiteFilterValueWrapper>
  )
}

const formattedStatus = siteStatuses
  .slice(4)
  .filter((status) => status.id !== SITE_STATUS_EDIT_ONLY_ID && status.id !== SITE_STATUS_SUBMITTED_EDIT_ONLY_ID)
  .map((status) => {
    return {
      label: statusMapping[status.name],
      value: status.id
    }
  })

const currentYear = new Date().getFullYear()

const formattedYears = range(currentYear, 1949, -1).map((year) => {
  return {
    label: year,
    value: year
  }
})

let sitesFetchAbortController = null
const SitesManagement = () => {
  const { profile } = useContext(ProfileContext)
  const { isModalOpen, toggleModal, siteData } = useContext(SitesModalContext)
  const {
    isMySite,
    getSitesCount,
    updateSitesFilters,
    siteFilters,
    sites: filteredSites,
    updateFilteredSites,
    pagination,
    resetFilters,
    isLoading: tableLoadingStatus,
    refreshFlag
  } = useContext(MySiteContext)
  const { countriesOptions } = useContext(CountriesContext)
  const { setPagination, selectPage, nextPage, prevPage, nextSection, prevSection, changeResultsPerPage } =
    usePersistPagination()
  const [countryCode, setCountryCode] = useState(siteFilters.country || null)
  const [siteStatus, setSiteStatus] = useState(siteFilters.status || null)
  const [year, setYear] = useState(siteFilters.year || null)
  const [sites, setSites] = useState(filteredSites)
  const [reassessmentSites, setReassessmentSites] = useState([])
  const [siteToWorkWith, setSiteToWorkWith] = useState({})
  const [siteToReject, setSiteToReject] = useState({})
  const [editOnlySiteToReject, setEditOnlySiteToReject] = useState(false)
  const [siteToPublish, setSiteToPublish] = useState(false)
  const [approveEditOnlyCallBack, setApproveEditOnlyCallBack] = useState(false)
  const [siteToDelist, setSiteToDelist] = useState(false)
  const [isSiteDoesNotQualified, setIsSiteDoesNotQualified] = useState(false)
  const [siteIsModalEditOpen, setSiteIsModalEditOpen] = useState({})

  const [isLoading, setIsLoading] = useState(true)

  // TODO: remove by using the useSiteManagementModals hook from src/hooks/useSiteManagementModals:
  const [siteForDeleting, setSiteForDeleting] = useState({})
  const [searchSitesQuery, setSearchSitesQuery] = useState('')
  const history = useNavigate()

  const assessSite = () => {
    requestReassesSite(siteData.id)
      .then((data) => {
        if (data.error) {
          return showErrorToast(data.error, 'showBorder')
        }

        toggleModal()
        setSites({
          id: siteData.id
        })
        history(buildDetailsUrl(siteData.id, data.historyId))
      })
      .catch((error) => {
        showErrorToast('An unexpected error occurred.', 'showBorder')
      })
  }

  async function editNowSite() {
    try {
      const data = await requestEditSite(siteIsModalEditOpen.id)

      if (data.error) {
        return showErrorToast(data.error, 'showBorder')
      }

      setSites({
        id: siteIsModalEditOpen.id
      })
      history(buildDetailsUrl(data.id, data.sitehistoryId, editOnly))
    } catch (error) {
      showErrorToast('An unexpected error occurred.', 'showBorder')
    }
  }
  const [sorting, setSorting] = useState({
    sortBy: 'name',
    sortDirection: sortDirection.ASC
  })

  // TODO: remove by using the useSiteManagementModals hook from src/hooks/useSiteManagementModals:
  function closeDelistModal() {
    setSiteToDelist(false)
  }
  // TODO: remove by using the useSiteManagementModals hook from src/hooks/useSiteManagementModals:
  function closeDoesNotQualifyModal() {
    setIsSiteDoesNotQualified(false)
  }
  // TODO: remove by using the useSiteManagementModals hook from src/hooks/useSiteManagementModals:
  function delistSite(site) {
    requestDelistState(site.historyId, { isApproved: site.isApproved }).then((data) => {
      setSiteToDelist(false)
    })
  }

  function getSites() {
    // Abort previous fetch request, if exists
    if (sitesFetchAbortController) {
      setIsLoading(false)
      sitesFetchAbortController.abort()
    }
    sitesFetchAbortController = new AbortController()
    const request = searchSitesQuery.length >= 3 ? requestGetSitesSearch : requestGetSites

    const params =
      searchSitesQuery.length >= 3
        ? {
          resultsPerPage: pagination.resultsPerPage,
          currentPage: pagination.currentPage,
          query: searchSitesQuery.toLowerCase().trim(),
          sortBy: sorting.sortBy,
          sortDirection: sorting.sortDirection
        }
        : {
          resultsPerPage: pagination.resultsPerPage,
          currentPage: pagination.currentPage,
          siteStatus: siteStatus ? siteStatus.value : '',
          year: year ? year.label : '',
          country: countryCode ? countryCode.value : '',
          sortBy: sorting.sortBy,
          sortDirection: sorting.sortDirection,
          toggle: isMySite,
          signal: sitesFetchAbortController.signal
        }

    setIsLoading(true)

    request(params)
      .then((data) => {
        setIsLoading(false)
        setSites(data.sites || [])
        updateFilteredSites(data.sites || [])
        setPagination(data.pagination || {})
      })
      .catch((error) => {
        setIsLoading(false) // Make sure loading indicator is turned off in case of error
        if (error.name === 'AbortError') {
          // Request was aborted, no need to handle it here
          return
        }
        setIsLoading(false)
      })
  }

  function delistSite(site) {
    requestDelistState(site.historyId, { isApproved: site.isApproved }).then((data) => {
      setSiteToDelist(false)
      getSites()
    })
  }

  useEffect(() => {
    if (searchSitesQuery.length > 2) {
      setCountryCode(null)
    }
  }, [searchSitesQuery])

  useEffect(() => {
    if (searchSitesQuery.length > 2) {
      setCountryCode(null)
    }
  }, [searchSitesQuery])

  useEffect(() => {
    getSites()
  }, [
    pagination?.currentPage,
    sorting.sortBy,
    sorting.sortDirection,
    pagination?.resultsPerPage,
    countryCode,
    siteStatus,
    year,
    searchSitesQuery
  ])

  useEffect(() => {
    getSites()
  }, [isMySite])

  useEffect(() => {
    if (!refreshFlag) return
    getSites()
  }, [refreshFlag])

  // TODO: remove by using the useSiteManagementModals hook from src/hooks/useSiteManagementModals:
  function deleteSite() {
    deleteSiteRequest(
      siteForDeleting.id,
      siteForDeleting.SiteStatus.id,
      siteForDeleting.reassessmentFlag,
      siteForDeleting.historyId
    ).then((data) => {
      if (data.error) {
        return showErrorToast(data.error, 'showBorder')
      }
      setSiteForDeleting({})
      getSites()
      getSitesCount(true)
    })
  }

  function handleCountryChange(e) {
    if (e.value === null) {
      resetFilters()
      return setCountryCode(null)
    }

    setCountryCode(e)
    updateSitesFilters('country', e)

    setPagination((s) => {
      return { ...s, currentPage: 1 }
    })
  }

  function handleSiteStatusChange(e) {
    if (e.value === null) {
      resetFilters()
      setSiteStatus(null)
      return
    }
    setSiteStatus(e)
    updateSitesFilters('status', e)
    setPagination((s) => {
      return { ...s, currentPage: 1 }
    })
  }

  function handleSiteYearChange(e) {
    if (e.value === null) {
      resetFilters()
      setYear(null)
      return
    }
    setYear(e)
    updateSitesFilters('year', e)

    setPagination((s) => {
      return { ...s, currentPage: 1 }
    })
  }

  const clearFilters = () => {
    setCountryCode(null)
    setYear(null)
    setSiteStatus(null)
    updateSitesFilters('year', null)
    updateSitesFilters('country', null)
    updateSitesFilters('status', null)
  }

  // TODO: remove by using the useSiteManagementModals hook from src/hooks/useSiteManagementModals:
  const rfpAction = async (site, isApproved) => {
    try {
      await requestReviewByRfp(site.id, site.historyId, isApproved);
      setSiteToWorkWith(false);
      setSiteToReject(false);
      await getSites();
    } catch (error) {
      throw new Error(error);
    }
  };

  // TODO: remove by using the useSiteManagementModals hook from src/hooks/useSiteManagementModals:
  const nominateSite = async (site) => {
    try {
      await requestNominateSite(site.id, site.historyId);
      setSiteToWorkWith(false);
      getSites();
    } catch (error) {
      throw new Error(error);
    }
  };

  // TODO: remove by using the useSiteManagementModals hook from src/hooks/useSiteManagementModals:
  const publishAction = async (site) => {
    try {
      await requestConfirmState(site.id, site.historyId, { isApproved: site.isApproved });
      setSiteToPublish(false);
      getSites();
    } catch (error) {
      throw new Error(error);
    }
  };

  async function deleteEditOnlySite() {
    try {
      const data = await deleteEditSiteOnlyRequest(editOnlySiteToReject.id, editOnlySiteToReject.siteStatusId)
      if (data?.error) {
        return showErrorToast(data.error, 'showBorder')
      }
      setEditOnlySiteToReject(false);
      getSites();
    } catch (err) {
      throw new Error(error);
    }
  }

  // TODO: remove by using the useSiteManagementModals hook from src/hooks/useSiteManagementModals:
  const approveEditsAction = async (site) => {
    try {
      await requestApproveEdits(site.id, site.historyId, { isApproved: site.isApproved });
      setApproveEditOnlyCallBack(false);
      getSites();
    } catch (error) {
      throw new Error(error);
    }
  }
  // TODO: remove by using the useSiteManagementModals hook from src/hooks/useSiteManagementModals:
  const doesNotQualify = async (site) => {
    try {
      const data = await requestDoesNotQualify(site.id);
      setIsSiteDoesNotQualified(false);
      await getSites();
    } catch (error) {
      throw new Error(error);
    }
  };

  // TODO: remove by using the useSiteManagementModals hook from src/hooks/useSiteManagementModals:
  const getSitesReassessments = async (siteId) => {
    try {
      const data = await requestAllSitesReassessments(siteId);

      const filteredData = data.filter((site) => {
        const isProposer = site.ProposerId === profile.id;
        const isCoProposer =
          Array.isArray(site.User?.SiteCoProposers) &&
          site.User.SiteCoProposers.some((coProposer) => coProposer.UserId === profile.id);
        const isViewable =
          profile.RoleId === 3 ||
          profile.RoleId === 4 ||
          [SITE_STATUS_CONFIRMED_ID, SITE_STATUS_SUPERSEDED_ID].includes(site.SiteStatusId);
        return isProposer || isCoProposer || isViewable;
      });

      // Extract and log the co-proposers based on site.historyId
      filteredData.forEach((site) => {
        if (Array.isArray(site.User?.SiteCoProposers)) {
          const coProposers = site.User.SiteCoProposers.map((coProposer) => coProposer.id);
        }
      });

      setReassessmentSites(filteredData);
    } catch (error) {
      throw new Error(error);
    }
  };

  function handleSearch(e) {
    setSearchSitesQuery(e.target.value)
    if (searchSitesQuery.length > 2) {
      setPagination((s) => {
        return { ...s, currentPage: 1 }
      })
    }
  }

  // TODO: remove by using the useSiteManagementModals hook from src/hooks/useSiteManagementModals:
  const showReassessmentListModal = (item) => {
    getSitesReassessments(item.id)
  }

  const columns = makeSitesColumns(sorting, setSorting, isMySite, profile)
  const rows = makeSitesRows(
    sites,
    setSiteToWorkWith,
    setSiteToReject,
    setSiteToPublish,
    setSiteToDelist,
    showReassessmentListModal,
    isMySite,
    setSiteForDeleting,
    setIsSiteDoesNotQualified,
    setSiteIsModalEditOpen,
    setApproveEditOnlyCallBack,
    setEditOnlySiteToReject
  )

  const setEmptyArray = () => {
    return setReassessmentSites([])
  }

  const formattedStatusAssessment = siteStatuses
    .filter((item) => {
      return profile.RoleId === 3 || profile.RoleId === 4
        ? item.id < SITE_STATUS_CONFIRMED_ID ||
        item.id === SITE_STATUS_EDIT_ONLY_ID ||
        item.id === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
        : item.id < SITE_STATUS_SUPERSEDED_ID ||
        item.id === SITE_STATUS_EDIT_ONLY_ID ||
        item.id === SITE_STATUS_SUBMITTED_EDIT_ONLY_ID
    })
    .map((status) => {
      return {
        label: statusMapping[status.name],
        value: status.id
      }
    })

  // consider making the view on map button a link that is only styled like a button...
  const handleViewOnMap = () => {
    history(SITES_MAP_PATH)
  }

  // TODO: replace all returned modal elements with the modalElements value from useSiteManagementModals:
  return (
    <>
      <Modal
        isOpen={isModalOpen}
        toggleModal={toggleModal}
        modalTitleId="Are you sure you want to complete a reassessment for this site?"
        width="616px"
        padding="0 32px 32px 32px"
      >
        <p style={{ fontSize: '14px', lineHeight: '24px' }}>
          <FormattedMessage id="reassessmentMessage" />
        </p>

        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button height="40px" marginTop="0px" onClick={toggleModal} type="delist">
            Cancel
          </Button>
          <Button height="40px" marginTop="0px" onClick={assessSite} type="primary">
            Continue{' '}
          </Button>
        </div>
      </Modal>

      <Modal
        isOpen={siteIsModalEditOpen?.id && siteIsModalEditOpen?.SiteStatus?.id == SITE_STATUS_CONFIRMED_ID || siteIsModalEditOpen?.SiteStatus?.id == SITE_STATUS_DELISTED_ID}
        toggleModal={setSiteIsModalEditOpen}
        modalTitleId="Are you sure you want to proceed with editing this site?"
        width="616px"
        padding="0 32px 32px 32px"
      >
        <p style={{ fontSize: '14px', lineHeight: '24px' }}>
          {' '}
          <FormattedMessage id="editOnlyMessage" />
        </p>
        <div style={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button
            height="40px"
            marginTop="0px"
            onClick={() => {
              setSiteIsModalEditOpen({})
            }}
            type="delist"
          >
            Cancel
          </Button>
          <Button height="40px" marginTop="0px" onClick={editNowSite} type="primary">
            Continue{' '}
          </Button>
        </div>
      </Modal>

      <SitesFilterSearchWrapper>
        <SitesFilterWrapper data-test="quick-filter">
          <SitesFilterItemWrapper>
            <Select
              field="country"
              value={countryCode}
              onChange={handleCountryChange}
              options={[{ label: 'View All', value: null }, ...countriesOptions]}
              placeholder="Country"
              height="40px"
              marginTop="10px"
            />
          </SitesFilterItemWrapper>
          <SitesFilterItemWrapper>
            <Select
              field="year"
              value={year}
              onChange={handleSiteYearChange}
              options={[{ label: 'View All', value: null }, ...formattedYears]}
              placeholder="Year"
              height="40px"
              marginTop="0px"
            />
          </SitesFilterItemWrapper>
          {isMySite ? (
            <SitesFilterItemWrapper>
              <Select
                field="assessment"
                value={siteStatus}
                onChange={handleSiteStatusChange}
                options={[{ label: 'View All', value: null }, ...formattedStatusAssessment]}
                placeholder="Assessment"
                height="40px"
                marginTop="0px"
              />
            </SitesFilterItemWrapper>
          ) : (
            <SitesFilterItemWrapper>
              <Select
                field="status"
                value={siteStatus}
                onChange={handleSiteStatusChange}
                options={[{ label: 'View All', value: null }, ...formattedStatus]}
                placeholder="Status"
                height="40px"
                marginTop="0px"
              />
            </SitesFilterItemWrapper>
          )}
        </SitesFilterWrapper>
        <Button onClick={handleViewOnMap} marginTop="0" type="accent" withIcon>
          <GlobeIcon />
          <FormattedMessage id="mapView" />
        </Button>
        <ResponsiveComponent>
          <SitesSearchWrapper>
            <SitesSearchInputWrapper>
              <SearchInput
                value={searchSitesQuery}
                onChange={handleSearch}
                placeholder="searchSitePlaceholder"
                type="text"
                dataTest="search-input"
              />
            </SitesSearchInputWrapper>
          </SitesSearchWrapper>
        </ResponsiveComponent>
      </SitesFilterSearchWrapper>
      <SitesTableWrapper>
        <LoadingWrapper size={'24px'} isLoading={tableLoadingStatus}>
          <Table
            columns={columns}
            rows={rows}
            clearFilters={clearFilters}
            noResultMessage="noSitesMatchFilteringCriteria"
            dataTest="sites-list"
            isLoading={isLoading}
          />
        </LoadingWrapper>
        <SitesFooterWrapper data-test="pagination">
          <ItemsPerPageDropdown
            currentPage={pagination.currentPage}
            resultsPerPage={pagination.resultsPerPage}
            totalNumber={pagination.totalNumber}
            onChange={changeResultsPerPage}
            dataTest="sites-items-per-page"
            menuPlacement="top"
          />
          {pagination.totalPages > 1 && (
            <Pagination
              activePages={pagination.currentPage}
              numberOfPages={pagination.totalPages}
              nextPage={nextPage}
              prevPage={prevPage}
              nextSection={nextSection}
              prevSection={prevSection}
              selectPage={selectPage}
              dataTest="page-number"
            />
          )}
        </SitesFooterWrapper>
      </SitesTableWrapper>
      <Modal
        width="496px"
        isOpen={
          siteToWorkWith.id &&
          (siteToWorkWith.SiteStatus?.id === SITE_STATUS_CONFIRMED_ID ||
            siteToWorkWith.SiteStatus.id === SITE_STATUS_DELISTED_ID)
        }
        toggleModal={setSiteToWorkWith}
        modalTitleId="supersede"
        bottomBorder={false}
        padding="0 32px 32px 32px"
      >
        <SiteSupersedeModal site={siteToWorkWith} toggleModal={setSiteToWorkWith} getSite={getSites} />
      </Modal>
      <Modal
        width="496px"
        isOpen={siteToWorkWith.id && siteToWorkWith.SiteStatus?.id === SITE_STATUS_SUPERSEDED_ID}
        toggleModal={setSiteToWorkWith}
        modalTitleId="changeStatus"
        bottomBorder={false}
        padding="0 32px 32px 32px"
      >
        <SiteRevertStatusModal site={siteToWorkWith} toggleModal={setSiteToWorkWith} getSite={getSites} />
      </Modal>
      <Modal
        width="496px"
        isOpen={siteToWorkWith.id && canReviewSites(profile.RoleId)}
        toggleModal={setSiteToWorkWith}
        modalTitleId="approveForNomination"
      >
        <FlowRequestModal
          cancelHandler={() => {
            setSiteToWorkWith(false)
          }}
          confirmHandler={rfpAction}
          confirmBtnText="approve"
          text={<FormattedMessage id="approveForNominationText" values={{ siteName: <b>{siteToWorkWith.name}</b> }} />}
          item={siteToWorkWith}
          approve={true}
        />
      </Modal>
      <Modal
        width="496px"
        isOpen={siteToReject.id && canReviewSites(profile.RoleId)}
        toggleModal={setSiteToReject}
        modalTitleId="returnDraft"
      >
        <FlowRequestModal
          cancelHandler={() => {
            setSiteToReject(false)
          }}
          confirmHandler={rfpAction}
          confirmBtnText="returnToDraft"
          text={<FormattedMessage id="returnFeedbackText" values={{ siteName: <b>{siteToReject.name}</b> }} />}
          item={siteToReject}
          approve={false}
        />
      </Modal>
      <Modal
        width="496px"
        isOpen={siteToWorkWith.id && (profile.RoleId === INDIVIDUAL_ROLE_ID || profile.RoleId === NCG_ROLE_ID)}
        toggleModal={setSiteToWorkWith}
        modalTitleId="nominateAssessment"
      >
        <FlowRequestModal
          cancelHandler={() => {
            setSiteToWorkWith(false)
          }}
          confirmHandler={nominateSite}
          confirmBtnText="nominate"
          text={<FormattedMessage id="nominateSiteText" values={{ siteName: <b>{siteToWorkWith.name}</b> }} />}
          item={siteToWorkWith}
          approve={true}
        />
      </Modal>
      <Modal
        width="496px"
        isOpen={siteToPublish.isApproved === true}
        toggleModal={setSiteToPublish}
        modalTitleId="confirmAssessment"
      >
        <FlowRequestModal
          cancelHandler={() => {
            setSiteToPublish(false)
          }}
          confirmHandler={publishAction}
          confirmBtnText="confirm"
          text={<FormattedMessage id="confirmAssessmentText" values={{ siteName: <b>{siteToPublish.name}</b> }} />}
          item={siteToPublish}
          approve={true}
        />
      </Modal>
      <Modal
        width="496px"
        isOpen={approveEditOnlyCallBack.isApproved === true}
        toggleModal={setApproveEditOnlyCallBack}
        modalTitleId="approveEdits"
      >
        <FlowRequestModal
          cancelHandler={() => {
            setApproveEditOnlyCallBack(false)
          }}
          confirmHandler={approveEditsAction}
          confirmBtnText="confirm"
          text={<FormattedMessage id="approveEditsText" values={{ siteName: <b>{approveEditOnlyCallBack.name}</b> }} />}
          item={approveEditOnlyCallBack}
          approve={true}
        />
      </Modal>
      <Modal
        width="496px"
        isOpen={approveEditOnlyCallBack.isApproved === false}
        toggleModal={setApproveEditOnlyCallBack}
        modalTitleId="rejectEdits"
      >
        <FlowRequestModal
          cancelHandler={() => {
            setApproveEditOnlyCallBack(false)
          }}
          confirmHandler={approveEditsAction}
          confirmBtnText="rejectBtn"
          text={<FormattedMessage id="rejectEditsText" values={{ siteName: <b>{approveEditOnlyCallBack.name}</b> }} />}
          item={approveEditOnlyCallBack}
          approve={false}
        />
      </Modal>
      <Modal
        width="496px"
        isOpen={siteToPublish.isApproved === false}
        toggleModal={setSiteToPublish}
        modalTitleId="rejectAssessment"
      >
        <FlowRequestModal
          cancelHandler={() => {
            setSiteToPublish(false)
          }}
          confirmHandler={publishAction}
          confirmBtnText="rejectBtn"
          text={<FormattedMessage id="rejectAssessmentText" values={{ siteName: <b>{siteToPublish.name}</b> }} />}
          item={siteToPublish}
          approve={false}
        />
      </Modal>
      <Modal width="496px" isOpen={siteToDelist.delist} toggleModal={closeDelistModal} modalTitleId="delistAssessment">
        <FlowRequestModal
          cancelHandler={closeDelistModal}
          confirmHandler={delistSite}
          confirmBtnText="delistBtn"
          text={<FormattedMessage id="delistAssessmentText" values={{ siteName: <b>{siteToDelist.name}</b> }} />}
          item={siteToDelist}
          approve={false}
        />
      </Modal>
      <Modal
        width="496px"
        isOpen={isSiteDoesNotQualified}
        toggleModal={closeDoesNotQualifyModal}
        modalTitleId="doesNotQualifyModal"
      >
        <FlowRequestModal
          cancelHandler={closeDoesNotQualifyModal}
          confirmHandler={doesNotQualify}
          confirmBtnText="confirm"
          text={<FormattedMessage id="doesNotQualifyText" values={{ siteName: <b>{isSiteDoesNotQualified.name}</b> }} />}
          item={isSiteDoesNotQualified}
          approve={true}
        />
      </Modal>
      <Modal
        width="496px"
        isOpen={editOnlySiteToReject}
        toggleModal={setEditOnlySiteToReject}
        modalTitleId='deleteEditSiteOnly'
      >
        <FlowRequestModal
          cancelHandler={() => {
            setEditOnlySiteToReject(false)
          }}
          confirmHandler={deleteEditOnlySite}
          confirmBtnText="yesDelete"
          text={<FormattedMessage id="editSiteForDeletingBody" values={{ siteName: <b>{editOnlySiteToReject.name}</b> }} />}
          item={editOnlySiteToReject}
          approve={false}
        />
      </Modal>
      <Modal
        width="729px"
        height="556px"
        isOpen={reassessmentSites.length > 0}
        toggleModal={setEmptyArray}
        modalTitleId="allAssessments"
        padding="32px"
        bottomBorder={true}
        infoHeader={reassessmentSites[0]?.name}
        assessmentValue={reassessmentSites.length}
        paddingBottom="12px"
        paddingTop="12px"
        marginLeft="none"
      >
        <AssessmentModal sites={reassessmentSites} />
      </Modal>

      <Modal width="496px" isOpen={siteForDeleting.id} toggleModal={setSiteForDeleting} modalTitleId="deleteDraft">
        <FlowRequestModal
          cancelHandler={() => {
            setSiteForDeleting(false)
          }}
          confirmHandler={deleteSite}
          confirmBtnText="yesDelete"
          text={<FormattedMessage id="siteForDeletingBody" values={{ siteName: <b>{siteForDeleting.name}</b> }} />}
          item={siteForDeleting}
          approve={false}
        />
      </Modal>
    </>
  )
}

export default SitesManagement
